module.exports = __webpack_public_path__ + "img/statisticsBlack.82042015.svg";